import { useEffect, useRef, type EffectCallback } from 'react';

const useStartupEffect = (effect: EffectCallback) => {
	const effectRef = useRef<EffectCallback>(effect);
	useEffect(() => {
		effectRef.current();
	}, []);
};

export default useStartupEffect;